export default __webpack_public_path__ + "static/media/minifonas.82d64925.webp";